import { observer } from "mobx-react-lite";
import React from "react";
import { useApp } from "../../../context";

import { Navigate, Outlet } from "react-router";

export const AnalyticRoot = observer(function AnalyticRoot() {
  const app = useApp();

  React.useEffect(() => {
    app.benchmarks.fetchCurrentBenchmark();
  }, [app.benchmarks.benchmark?.id]);

  if (!app.benchmarks.benchmark) {
    return <Navigate to="/benchmark" />;
  }

  return <Outlet />;
});
